import React from 'react'
import { AuthRouteImport } from './Import'
import PageNotFound from './PageNotFound'
const { RoutesMap, UserLogin } = AuthRouteImport

const AuthRoute = () => {
    return [
        {
            path: RoutesMap.LOGIN.path,
            element: <UserLogin />
        },
        {
            path: RoutesMap.UNKNOWN_PATH.path,
            element: <PageNotFound />
        },
    ]
}

export default AuthRoute;